// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  seasonId: __t.u32().name("season_id"),
  tierNumber: __t.u32().name("tier_number"),
  freeRewardType: __t.string().name("free_reward_type"),
  freeRewardCoins: __t.i64().name("free_reward_coins"),
  freeRewardItemId: __t.option(__t.u64()).name("free_reward_item_id"),
  premiumRewardType: __t.string().name("premium_reward_type"),
  premiumRewardCoins: __t.i64().name("premium_reward_coins"),
  premiumRewardItemId: __t.option(__t.u64()).name("premium_reward_item_id"),
});
